<template>
	<Dialog
		class="apps__devices-dialog"
		modal
		:header="props.header"
		:visible="props.visible"
		@update:visible="emit('update:visible', $event)">
		<DataTable
			class="apps__devices-table"
			responsive-layout="scroll"
			:value="props.tokens">
			<template #empty>
				<div class="apps__empty">No connected devices found.</div>
			</template>
			<Column
				field="id"
				header="Token" />
			<Column header="Scopes">
				<template #body="{ data }">
					<div class="apps__scopes">
						<Tag
							v-for="scope in data.scopes"
							:key="`${data.id}-${scope}`"
							severity="secondary"
							:value="scope" />
					</div>
				</template>
			</Column>
			<Column header="Created">
				<template #body="{ data }">
					{{ formatDate(data.created_at) }}
				</template>
			</Column>
			<Column header="Expires">
				<template #body="{ data }">
					{{ formatDate(data.expires_at) }}
				</template>
			</Column>
			<Column header-style="width: 40px">
				<template #body="{ data }">
					<DataTableButton
						aria-label="Revoke token"
						icon="fal fa-trash"
						severity="danger"
						title="Revoke token"
						:disabled="props.revokingTokenIds.has(data.id)"
						:loading="props.revokingTokenIds.has(data.id)"
						@click="emit('revoke', data.id)" />
				</template>
			</Column>
		</DataTable>
	</Dialog>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import Tag from 'primevue/tag'
import DataTableButton from '@/components/Table/DataTableButton.vue'
import type { McpConnection } from '@/models/Mcp/Types'

const props = defineProps<{
	visible: boolean
	header: string
	tokens: McpConnection['tokens']
	revokingTokenIds: Set<string>
}>()

const emit = defineEmits<{
	(e: 'update:visible', value: boolean): void
	(e: 'revoke', tokenId: string): void
}>()

function formatDate(value: string | null): string {
	if (!value) return '-'

	return format(new Date(value), 'MMM d, yyyy')
}
</script>

<style scoped lang="scss">
.apps__scopes {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.apps__empty {
	text-align: center;
	padding: 32px;
	color: var(--p-text-muted-color);
}
</style>

<style lang="scss">
.apps__devices-dialog {
	min-width: min(1000px, 92vw);

	.apps__devices-table {
		margin-top: 6px;
	}
}
</style>
